import useTiposAreaComum from "core/features/area-comum/hooks/useTiposAreaComum";
import { useState } from "react";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";

function SelectTipoAreaComum({ ...rest }: SelectBaseAntdProps) {
  const [search, setSearch] = useState<string | undefined>();
  const { isLoading, data } = useTiposAreaComum();

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione o tipo de Área Comum"
      searchValue={search}
      onSearch={setSearch}
      {...rest}
      showSearch
      allowClear
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectTipoAreaComum;
